import { ComponentIds, ConnectorsComponent } from '@inter-ikea-core/core';
import { isOfType, ProductType, PlannerProductComponent, getProductReferenceFor, ShoppingBagComponent, InteriorComponent, HideFromAssemblyInstructionsComponent, OuterMeasurementsComponent, PartKey, WallVisibilityComponent, HideInSeeThroughSystemComponent, ScreenshotComponent, AssemblyInstructionsComponent, CornerSolutionComponent } from '@inter-ikea-storageone/range';
export const ivarComponentResolver = (_coreApi, _products, _unavailableProducts, _productsNotInMarket, _coreSpecificProducts) => {
    const isShoppingProduct = isOfType([
        ProductType.IVAR_SIDE_UNIT,
        ProductType.IVAR_CROSS_BRACE,
        ProductType.IVAR_SHELF_PINE,
        ProductType.IVAR_SHELF_FELT,
        ProductType.IVAR_SHELF_METAL,
        ProductType.IVAR_CLOTHES_RAIL,
        ProductType.IVAR_BOTTLE_RACK,
        ProductType.IVAR_DRAWER_PINE,
        ProductType.IVAR_DRAWER_METAL,
        ProductType.IVAR_TABLE,
        ProductType.IVAR_STORAGE_BOX,
        ProductType.IVAR_UNDERFRAME,
        ProductType.IVAR_CABINET,
        ProductType.IVAR_DOOR,
        ProductType.IVAR_HOOKS,
        ProductType.IVAR_END_PROTECTORS,
        ProductType.IVAR_CORNER_POST,
        ProductType.IVAR_CORNER_SHELF,
        ProductType.SAMLA_ORGANIZER,
        ProductType.SOCKERBIT_ORGANIZER,
        ProductType.KUGGIS_ORGANIZER,
        ProductType.KNAGGLIG_ORGANIZER
    ]);
    //Should include all product types that should be displayed in the product sidebar
    const isPlannerProduct = isOfType([
        ProductType.IVAR_SECTION,
        ProductType.IVAR_CORNER_SECTION,
        ProductType.IVAR_CORNER_SECTION_W_SHELVES,
        ProductType.IVAR_SHELF_PINE,
        ProductType.IVAR_SHELF_FELT,
        ProductType.IVAR_SHELF_METAL,
        ProductType.IVAR_CLOTHES_RAIL,
        ProductType.IVAR_BOTTLE_RACK,
        ProductType.IVAR_DRAWER_PINE,
        ProductType.IVAR_DRAWER_METAL,
        ProductType.IVAR_TABLE,
        ProductType.IVAR_STORAGE_BOX,
        ProductType.IVAR_CABINET_WITH_UNDERFRAME,
        ProductType.IVAR_CABINET,
        ProductType.IVAR_DOOR_ADJACENT,
        ProductType.IVAR_CORNER_SHELF,
        ProductType.SAMLA_ORGANIZER,
        ProductType.SOCKERBIT_ORGANIZER,
        ProductType.KUGGIS_ORGANIZER,
        ProductType.KNAGGLIG_ORGANIZER
    ]);
    const shouldBeIncludedInOuterMeasurement = isOfType([
        ProductType.IVAR_SIDE_UNIT,
        ProductType.IVAR_CABINET,
        ProductType.IVAR_UNDERFRAME,
        ProductType.IVAR_TABLE
    ]);
    const hideInSeeThroughEntitySystem = isOfType([
        ProductType.IVAR_STORAGE_BOX,
        ProductType.IVAR_SECTION,
        ProductType.IVAR_CORNER_SECTION,
        ProductType.IVAR_CABINET_WITH_UNDERFRAME,
        ProductType.IVAR_CABINET
    ]);
    const isInterior = isOfType([
        ProductType.IVAR_SHELF_PINE,
        ProductType.IVAR_SHELF_FELT,
        ProductType.IVAR_SHELF_METAL,
        ProductType.IVAR_CLOTHES_RAIL,
        ProductType.IVAR_BOTTLE_RACK,
        ProductType.IVAR_DRAWER_PINE,
        ProductType.IVAR_DRAWER_METAL,
        ProductType.IVAR_TABLE,
        ProductType.IVAR_CORNER_SHELF,
        ProductType.IVAR_CABINET
    ]);
    const shouldHaveAssemblyInstructions = isOfType([
        ProductType.IVAR_SECTION,
        ProductType.IVAR_CORNER_SECTION
    ]);
    const shouldBeRemovedFromAssemblyImages = isOfType([ProductType.IVAR_DOOR]);
    const isStorageBox = isOfType([ProductType.IVAR_STORAGE_BOX]);
    const isCornerSolution = isOfType([ProductType.IVAR_CORNER_SECTION]);
    const ignoredProductPartKeys = [PartKey.IVAR_CABINET];
    const shouldExcludeProduct = (entity) => {
        return !!(entity.hasComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID) &&
            ignoredProductPartKeys.includes(entity.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID).partKey));
    };
    const componentBuilder = {
        build: (entity) => {
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                entity.addComponent(new OuterMeasurementsComponent());
            }
            if (shouldHaveAssemblyInstructions(entity)) {
                entity.addComponent(new AssemblyInstructionsComponent());
            }
            if (isPlannerProduct(entity) && !shouldExcludeProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
            }
            if (isInterior(entity)) {
                entity.addComponent(new InteriorComponent());
            }
            if (isCornerSolution(entity)) {
                entity.addComponent(new CornerSolutionComponent());
            }
            if (shouldBeRemovedFromAssemblyImages(entity)) {
                entity.addComponent(new HideFromAssemblyInstructionsComponent());
            }
            if (hideInSeeThroughEntitySystem(entity)) {
                entity.addComponent(new HideInSeeThroughSystemComponent());
            }
            if (isStorageBox(entity)) {
                // Don't allow storage box to be placed in middle of room
                const connectorsComponent = entity.getComponent(ComponentIds.CONNECTORS_COMPONENT_ID);
                const filteredConnectors = connectorsComponent?.connectors.filter(c => c.key !== 'floor-connector');
                filteredConnectors && entity.addComponent(new ConnectorsComponent(filteredConnectors));
                entity.addComponent(new WallVisibilityComponent());
                entity.addComponent(new ScreenshotComponent());
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=ivarComponentResolver.js.map